import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { filter, switchMap, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

//	This is ensure the request won't be sent during handle redirect observable
@Injectable()
export class MsalAuthInterceptor implements HttpInterceptor {

	constructor(private readonly authService: AuthService) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (req.url.startsWith(environment.API_BASE_URL)) {
			return this.authService.isAuthenticated$.pipe(
				filter(val => val),
				take(1),
				switchMap(_ => next.handle(req))
			);
		}

		return next.handle(req);
	}
}